<script setup lang="ts">
definePageMeta({ layout: 'default' })

useHead({
  title: 'Datenschutz'
})
</script>

<template>
  <div id="privacy" class="row g-2 justify-content-center my-5">
    <div class="col-xxl-6 col-xl-7 col-lg-8 col-md-11 hyphenate">
      <h1>Datenschutzerklärung</h1>
      <p>Bei jeder Anfrage an die API werden folgende Daten von den Webservern gespeichert:</p>
      <ul>
        <li>Der User Agent</li>
        <li>Der Zeitpunkt des Aufrufs</li>
        <li>Die verwendete IP-Adresse</li>
        <li>Die Anfrageparameter (z.B. die Suchkriterien einer Zugverbindung)</li>
      </ul>
      <p>
        Die API wird von der Webseite aufgerufen, um die Autovervollständigung bei der Bahnhofssuche
        anzuzeigen, um Zugverbindungen zu finden und um Statistiken und Daten anzuzeigen.
      </p>
      <p>
        Die Daten werden verwendet um nachzuvollziehen, wie viel und welche Aspekte der Projekts
        verwendet werden. Es ist für uns nicht möglich, die Daten einzelnen Personen zuzuordnen.
      </p>
    </div>
  </div>
</template>
